@if (surfaceBet) {
    <div class="surface-bet-card" data-crlat="surfaceBetCard" [ngClass]="{ 'surface-bet-card-reaction': sbReactionConfig?.enabled }">
        <div [appSymbolBackground]="surfaceBet" class="surface-bet-card surface-bet-card-container">
            <div class="left-side flex-grow-1">
                <div class="surface-bet-header" data-crlat="surfaceBetCard.header">
                    @if (surfaceBet.svgId) {
                        <div class="bet-img-container" data-crlat="surfaceBetCard.icon">
                            <svg [class.brand-color]="surfaceBet.svgId">
                                <use [attr.xlink:href]="'#' + surfaceBet.svgId"></use>
                            </svg>
                        </div>
                    }
                    <div class="surface-bet-title brand-title-color" [textContent]="surfaceBet.title" data-crlat="surfaceBetCard.title"></div>
                    <div class="header-background"></div>
                </div>
                <div class="surface-bet-content content-color" [ngClass]="{ 'mb-2': sbReactionConfig?.enabled }">
                    <div
                        class="surface-bet-contentHeader"
                        [textContent]="surfaceBet.contentHeader || ''"
                        data-crlat="surfaceBetCard.contentHeader"></div>
                    <div
                        [ngClass]="{ 'mb-3': sbReactionConfig?.enabled }"
                        [textContent]="surfaceBet.content || ''"
                        data-crlat="surfaceBetCard.content"></div>
                </div>
            </div>
            <div>
                @if (isButton) {
                    <div class="price-odd-container">
                        <price-odds-button
                            [event]="surfaceBet"
                            [market]="surfaceBet.markets[0]"
                            [outcome]="surfaceBet.markets[0].outcomes[0]"
                            [cssClass]="'surface-bet-btn'"
                            [isShowHistoricPrices]="false"
                            [gtmModuleTitle]="'surface bets'"
                            [sbPosition]="surfaceBetIndex">
                        </price-odds-button>
                    </div>
                }
                @if (oldPrice) {
                    <div class="was-price content-color" data-crlat="surfaceBetCard.oldPrice">
                        <span [i18n]="'sb.wasPrice'" data-crlat="label"></span>
                        <strike class="content-color" [textContent]="oldPrice" data-crlat="value"></strike>
                    </div>
                }
            </div>
        </div>
        @if (sbReactionConfig?.enabled) {
            <odds-card-surface-bet-reactions
                [surfaceBet]="surfaceBet"
                [isEdp]="isEdp"
                (reactionsLoaded)="reactionsLoaded()"
                [hubIndex]="hubIndex"
                [sportId]="sportId"
                [sportName]="sportName"
                [sbReactionConfig]="sbReactionConfig"
                [singleReactionCount]="singleReactionCount"></odds-card-surface-bet-reactions>
        }
    </div>
}
